import React from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "../contextapi/hooks/useAuth";

const accessToken = window.localStorage.getItem("accessToken");

const AuthGuard = ({ children }) => {
  const { isAuthenticated, logoutUser, user } = useAuth();

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  }
  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
